import {
  Box,
  Button,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { decodeToken, OperationType } from '../../../../utils/settings';
import {
  createBusinessProfilerAction,
  getbusinessProfilerAction,
  patchbusinessProfilerAction,
} from '../../action';
import { toast, ToastContainer } from 'react-toastify';

function WareHouseDetails() {
  const [open, setOpen] = useState(false);
  const [warehouseDetailsList, setWarehouseDetailsList] = useState({});
  const [warehouseDetails, setWarehouseDetails] = useState({});
  const [addedWarehouses, setAddedWarehouses] = useState([]);
  const [firmDetails, setFirmDetails] = useState({});
  const [editing, setEditing] = useState(false);

  const getprofiler = async () => {
    const { data, error, message } = await getbusinessProfilerAction();

    if (!error) setWarehouseDetailsList(data.warehouse_details);
    else toast.error(message);
  };

  useEffect(() => {
    getprofiler();

    decodeToken().then(({ default_company_info }) => {
      setFirmDetails(default_company_info);
    });
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setEditing(false);
    setWarehouseDetails({});
    setAddedWarehouses([]);
  };

  const addWarehouse = () => {
    if (!warehouseDetails.area_in_sq_ft)
      return toast.error('Please Enter Area');
    if (
      warehouseDetails.is_your_warehouse_covered === null ||
      warehouseDetails.is_your_warehouse_covered === undefined
    )
      return toast.error('Please Select Coverage');

    const payload = {
      area_in_sq_ft: warehouseDetails.area_in_sq_ft,
      is_your_warehouse_covered: warehouseDetails.is_your_warehouse_covered,
    };

    setWarehouseDetails({});
    setAddedWarehouses([...addedWarehouses, payload]);
    toast.success('Warehouse Saved');
  };

  const onFinish = async () => {
    const payload = {
      warehouse_details: {
        firm_id: firmDetails.company_id,
        warehouse_list: addedWarehouses,
      },
    };

    const { error, message } = await createBusinessProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getprofiler();
    } else {
      toast.error(message);
    }
  };

  const onEdit = (data) => {
    setEditing(true);
    setOpen(true);

    const payload = {
      ...data,
      is_your_warehouse_covered: data.is_your_warehouse_covered === 'True',
    };

    setWarehouseDetails(payload);
  };

  const onEditFinish = async () => {
    if (!warehouseDetails.area_in_sq_ft)
      return toast.error('Please Enter Area');
    if (
      warehouseDetails.is_your_warehouse_covered === null ||
      warehouseDetails.is_your_warehouse_covered === undefined
    )
      return toast.error('Please Select Coverage');

    const payload = {
      warehouse_details: {
        firm_id: firmDetails.company_id,
        warehouse_list: [
          {
            id: warehouseDetails.id,
            operation_type: OperationType['UPDATE'],
            area_in_sq_ft: warehouseDetails.area_in_sq_ft,
            is_your_warehouse_covered:
              warehouseDetails.is_your_warehouse_covered,
          },
        ],
      },
    };

    const { error, message } = await patchbusinessProfilerAction(payload);

    if (!error) {
      toast.success(message);
      handleClose();
      getprofiler();
    } else {
      toast.error(message);
    }
  };

  return (
    <div>
      <ToastContainer className='custom-toast-container' />
      <CardContent
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 25,
        }}>
        {Object.keys(warehouseDetailsList).length > 0 &&
          warehouseDetailsList?.warehouse_list.map((vv, ii) => {
            return (
              <Box
                sx={{
                  borderWidth: 2,
                  borderColor: '#F59C1E',
                  borderStyle: 'solid',
                  padding: 2,
                  borderRadius: 2,
                  position: 'relative',
                  marginBottom: 3,
                }}>
                <div
                  className='editCtr'
                  onClick={() => onEdit(vv)}>
                  <Tooltip title='Edit Details'>
                    <EditIcon color='primary' />
                  </Tooltip>
                </div>
                <div
                  className='row-center'
                  style={{
                    justifyContent: 'space-between',
                    marginBottom: 10,
                  }}>
                  <div className='row-center'>
                    <Typography
                      fontSize={15}
                      sx={{ marginRight: 1 }}>
                      Warehouse
                    </Typography>
                    -
                    <Typography
                      fontSize={15}
                      fontWeight={'600'}
                      sx={{ marginLeft: 1 }}>
                      {ii + 1}
                    </Typography>
                  </div>

                  <div className='row-center'>
                    <Typography
                      fontSize={15}
                      sx={{ marginRight: 1 }}>
                      Area
                    </Typography>
                    -
                    <Typography
                      fontSize={15}
                      fontWeight={'600'}
                      sx={{ marginLeft: 1 }}>
                      {vv.area_in_sq_ft} Sq Ft
                    </Typography>
                  </div>
                </div>

                <div
                  className='row-center'
                  style={{
                    justifyContent: 'space-between',
                    marginBottom: 10,
                  }}>
                  <div className='row-center' />

                  <div className='row-center'>
                    <Typography
                      fontSize={15}
                      sx={{ marginRight: 1 }}>
                      Is Covered?
                    </Typography>
                    -
                    <Typography
                      fontSize={15}
                      fontWeight={'600'}
                      sx={{ marginLeft: 1 }}>
                      {vv.is_your_warehouse_covered}
                    </Typography>
                  </div>
                </div>
              </Box>
            );
          })}
      </CardContent>

      <div
        className='row-center'
        style={{
          justifyContent: 'flex-end',
        }}>
        <div>
          <Button
            onClick={handleOpen}
            sx={{ width: 150 }}
            variant='contained'>
            Add Details
          </Button>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={{
            backgroundColor: 'white',
            width: '70%',
            overflowY: 'scroll',
            maxHeight: '90vh',
            borderRadius: '10px',
            padding: '20px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}>
          <CardContent>
            <div className='title-Ctr'>
              <Typography
                variant='h5'
                fontWeight={'600'}>
                Add Warehouse Details
              </Typography>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Firm Name
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Firm Name'
                  name='name'
                  value={firmDetails?.company_name}
                  disabled
                  fullWidth
                  margin='normal'
                />
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Area in Sq.Ft
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <TextField
                  label='Area in Sq.Ft'
                  name='area_in_sq_ft'
                  value={warehouseDetails?.area_in_sq_ft || ''}
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value;
                    setWarehouseDetails((prev) => ({
                      ...prev,
                      area_in_sq_ft: value,
                    }));
                  }}
                  margin='normal'
                />
              </div>
            </div>

            <div className='form-row-ctr'>
              <div className='form-row-ctr-left'>
                <Typography
                  variant='h6'
                  fontSize={15}>
                  Is Your Warehouse Covered?
                </Typography>
              </div>
              <div className='form-row-ctr-right'>
                <FormControl
                  // disabled={isEditing || isAddingMember}
                  fullWidth
                  margin='normal'>
                  <InputLabel id='demo-simple-select-label-is_your_warehouse_covered'>
                    Is Your Warehouse Covered?
                  </InputLabel>
                  <Select
                    labelId='demo-simple-select-label-is_your_warehouse_covered'
                    id='demo-simple-select'
                    value={warehouseDetails.is_your_warehouse_covered}
                    label='Is Your Warehouse Covered?'
                    onChange={(e) => {
                      const value = e.target.value;
                      setWarehouseDetails((prev) => ({
                        ...prev,
                        is_your_warehouse_covered: value,
                      }));
                    }}>
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>

            {editing ? (
              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}>
                <div>
                  <Button
                    onClick={onEditFinish}
                    sx={{ marginTop: 2 }}
                    variant='contained'>
                    Update Details
                  </Button>
                </div>
              </div>
            ) : (
              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}>
                <div>
                  <Button
                    onClick={addWarehouse}
                    sx={{ width: 150, marginTop: 2 }}
                    variant='outlined'>
                    Save
                  </Button>
                </div>
              </div>
            )}
          </CardContent>

          {addedWarehouses.length > 0 && (
            <CardContent>
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Area in Sq.Ft</TableCell>
                      <TableCell align='right'>Is Covered</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {addedWarehouses.map((row) => (
                      <TableRow
                        key={`${row.area_in_sq_ft}`}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}>
                        <TableCell
                          component='th'
                          scope='row'>
                          {row.area_in_sq_ft}
                        </TableCell>
                        <TableCell align='right'>
                          {row.is_your_warehouse_covered ? 'Yes' : 'No'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div
                className='row-center'
                style={{
                  justifyContent: 'flex-end',
                }}>
                <div>
                  <Button
                    onClick={onFinish}
                    sx={{ marginTop: 2 }}
                    variant='contained'>
                    Submit Details
                  </Button>
                </div>
              </div>
            </CardContent>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default WareHouseDetails;
